import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'users-staff',
  templateUrl: '../../templates/partials/users-staff.html'
})
export class UsersStaffComponent{

    @Input() staff;
    public selected;
    @Output() usersEmitter = new EventEmitter();

    public selectStaff(person,index) {
      //console.log(person);
      this.selected = index;
      this.usersEmitter.emit({action: "edit", data: person});
    }

    public createStaff(){
      this.usersEmitter.emit({action: "create", data: null});
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/staff/components/dummy/users-staff.component.ts